module.exports = __webpack_public_path__ + "static/media/button-check.dade6eeb.svg";